<template>
  <AdminLayout title="个人中心">
    <!-- 消息提示 -->
    <div v-if="message" class="message-toast" :class="messageType">{{ message }}</div>

    <div class="profile-container">
      <!-- 专属链接卡片 -->
      <div class="profile-card">
        <div class="card-header">
          <h3>专属链接</h3>
        </div>
        <div class="card-body">
          <div class="link-form">
            <div class="form-item">
              <label>选择区域 <span class="required">*</span></label>
              <select v-model="selectedArea">
                <option value="">请选择区域</option>
                <option value="高淳">高淳</option>
                <option value="鼓楼">鼓楼</option>
                <option value="化工园">化工园</option>
                <option value="建邺">建邺</option>
                <option value="江宁">江宁</option>
                <option value="溧水">溧水</option>
                <option value="六合">六合</option>
                <option value="浦口">浦口</option>
                <option value="栖霞">栖霞</option>
                <option value="秦淮">秦淮</option>
                <option value="玄武">玄武</option>
                <option value="雨花">雨花</option>
                <option value="开渠">开渠</option>
              </select>
            </div>
            <div class="form-item">
              <label class="checkbox-label">
                <input type="checkbox" v-model="includePersonalParams">
                <span>包含个人参数（取消后仅生成地区链接）</span>
              </label>
            </div>
            <div class="form-item" v-if="generatedLink">
              <label>专属链接</label>
              <div class="link-display">
                <input type="text" :value="generatedLink" readonly>
                <button type="button" class="copy-link-btn" @click="copyLink">
                  <span class="iconify" data-icon="hugeicons:copy-01"></span>
                  复制
                </button>
              </div>
            </div>
            <div class="form-item" v-if="qrCodeUrl">
              <label>专属二维码</label>
              <div class="qrcode-container">
                <img :src="qrCodeUrl" alt="专属链接二维码" class="qrcode-image">
                <button type="button" class="download-qrcode-btn" @click="downloadQrcode">
                  <span class="iconify" data-icon="hugeicons:download-01"></span>
                  下载二维码
                </button>
              </div>
            </div>
            <div class="form-actions">
              <button class="generate-link-btn" @click="generateLink" :disabled="!selectedArea">
                <span class="iconify" data-icon="hugeicons:link-01"></span>
                生成链接
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 修改联系方式卡片 -->
      <div class="profile-card">
        <div class="card-header">
          <h3>个人信息修改</h3>
        </div>
        <div class="card-body">
          <div class="contact-form">
            <div class="form-item">
              <label>用户名</label>
              <input type="text" :value="profile.username" disabled class="disabled-input">
            </div>
            <div class="form-item">
              <label>昵称</label>
              <input type="text" :value="profile.nickname" disabled class="disabled-input">
            </div>
            <div class="form-item">
              <label>手机号</label>
              <div class="input-with-hint">
                <input type="text" v-model="contactForm.phone" placeholder="请输入手机号（可选）">
                <div class="input-hint" v-if="contactForm.phone && validatePhone(contactForm.phone)">
                  {{ validatePhone(contactForm.phone) }}
                </div>
              </div>
            </div>
            <div class="form-item">
              <label>邮箱</label>
              <div class="input-with-hint">
                <input type="email" v-model="contactForm.email" placeholder="请输入邮箱（可选）">
                <div class="input-hint" v-if="contactForm.email && validateEmail(contactForm.email)">
                  {{ validateEmail(contactForm.email) }}
                </div>
              </div>
            </div>
            <div class="form-actions">
              <button class="submit-btn" @click="updateContact" :disabled="contactLoading">
                {{ contactLoading ? '提交中...' : '保存修改' }}
              </button>
              <button class="reset-btn" @click="initContactForm">
                重置
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 修改密码卡片 -->
      <div class="profile-card">
        <div class="card-header">
          <h3>修改密码</h3>
        </div>
        <div class="card-body">
          <div class="password-form">
            <div class="form-item">
              <label>旧密码 <span class="required">*</span></label>
              <div class="password-input-wrapper">
                <input :type="showOldPassword ? 'text' : 'password'" v-model="passwordForm.oldPassword" placeholder="请输入旧密码">
                <button type="button" class="toggle-btn" @click="showOldPassword = !showOldPassword">
                  <span class="iconify" :data-icon="showOldPassword ? 'hugeicons:view-off' : 'hugeicons:view'"></span>
                </button>
              </div>
            </div>
            <div class="form-item">
              <label>新密码 <span class="required">*</span></label>
              <div class="password-input-wrapper">
                <input :type="showNewPassword ? 'text' : 'password'" v-model="passwordForm.newPassword" placeholder="请输入新密码">
                <button type="button" class="toggle-btn" @click="showNewPassword = !showNewPassword">
                  <span class="iconify" :data-icon="showNewPassword ? 'hugeicons:view-off' : 'hugeicons:view'"></span>
                </button>
              </div>
              <div class="password-hint" :class="{ 'hint-error': passwordError }">{{ passwordHint }}</div>
            </div>
            <div class="form-item">
              <label>确认新密码 <span class="required">*</span></label>
              <div class="password-input-wrapper">
                <input :type="showConfirmPassword ? 'text' : 'password'" v-model="passwordForm.confirmPassword" placeholder="请再次输入新密码">
                <button type="button" class="toggle-btn" @click="showConfirmPassword = !showConfirmPassword">
                  <span class="iconify" :data-icon="showConfirmPassword ? 'hugeicons:view-off' : 'hugeicons:view'"></span>
                </button>
              </div>
            </div>
            <div class="form-actions">
              <button class="submit-btn" @click="changePassword" :disabled="loading">
                {{ loading ? '提交中...' : '修改密码' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from '../../components/manage/ManageLayout.vue';
import { request } from '../../utils/request';
import JSEncrypt from 'jsencrypt';
import config from '../../config';

const API_BASE_URL = config.API_BASE_URL;

export default {
  name: 'UserProfile',
  components: { AdminLayout },
  data() {
    return {
      profile: {},
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      loading: false,
      publicKey: '',
      message: '',
      messageType: '',
      passwordError: false,
      selectedArea: '',
      includePersonalParams: true,
      generatedLink: '',
      qrCodeUrl: '',
      contactForm: {
        phone: '',
        email: ''
      },
      contactLoading: false
    };
  },
  computed: {
    passwordHint() {
      return this.validatePassword(this.passwordForm.newPassword);
    }
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    async getPublicKey() {
      try {
        const response = await fetch(`${API_BASE_URL}/api/open/auth/public-key`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        if (data.code === '200') {
          this.publicKey = data.data.publicKey;
        }
      } catch (error) {
        this.showMessage('获取公钥失败', 'error');
      }
    },
    encryptData(data) {
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(this.publicKey);
      return encrypt.encrypt(data);
    },
    validatePassword(password) {
      if (!password) return '请输入密码';
      if (password.length < 8) return '密码长度至少为8位';
      let typeCount = 0;
      if (/[0-9]/.test(password)) typeCount++;
      if (/[a-z]/.test(password)) typeCount++;
      if (/[A-Z]/.test(password)) typeCount++;
      if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password)) typeCount++;
      if (typeCount < 3) return '密码必须包含数字、大写字母、小写字母、特殊符号中的至少三种';
      return '密码强度符合要求';
    },
    isPasswordWeak(password) {
      return this.validatePassword(password) !== '密码强度符合要求';
    },
    async getProfile() {
      try {
        const response = await request(`${API_BASE_URL}/api/user/profile`, {
          body: JSON.stringify({})
        });
        if (response.code === '200') {
          this.profile = response.data;
          this.initContactForm();
        }
      } catch (error) {
        this.showMessage('获取用户信息失败', 'error');
      }
    },
    async changePassword() {
      if (!this.passwordForm.oldPassword) {
        this.showMessage('请输入旧密码', 'error');
        return;
      }
      if (!this.passwordForm.newPassword) {
        this.showMessage('请输入新密码', 'error');
        return;
      }
      if (this.isPasswordWeak(this.passwordForm.newPassword)) {
        this.passwordError = true;
        this.showMessage(this.passwordHint, 'error');
        return;
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.showMessage('两次输入的新密码不一致', 'error');
        return;
      }
      if (this.passwordForm.oldPassword === this.passwordForm.newPassword) {
        this.showMessage('新密码不能与旧密码相同', 'error');
        return;
      }

      this.loading = true;
      try {
        await this.getPublicKey();
        const response = await request(`${API_BASE_URL}/api/user/change-password`, {
          body: JSON.stringify({
            encryptedOldPassword: this.encryptData(this.passwordForm.oldPassword),
            encryptedNewPassword: this.encryptData(this.passwordForm.newPassword)
          })
        });
        if (response.code === '200') {
          this.showMessage('密码修改成功', 'success');
          this.passwordForm = { oldPassword: '', newPassword: '', confirmPassword: '' };
        } else {
          this.showMessage(response.message || '修改失败', 'error');
        }
      } catch (error) {
        this.showMessage('修改失败', 'error');
      } finally {
        this.loading = false;
      }
    },
    validatePhone(phone) {
      if (!phone) return null;
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(phone)) {
        return '手机号格式不正确，应为11位数字且以1开头';
      }
      return null;
    },
    validateEmail(email) {
      if (!email) return null;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        return '邮箱格式不正确';
      }
      return null;
    },
    initContactForm() {
      this.contactForm.phone = this.profile.phone || '';
      this.contactForm.email = this.profile.email || '';
    },
    async updateContact() {
      const phoneError = this.validatePhone(this.contactForm.phone);
      if (phoneError) {
        this.showMessage(phoneError, 'error');
        return;
      }

      const emailError = this.validateEmail(this.contactForm.email);
      if (emailError) {
        this.showMessage(emailError, 'error');
        return;
      }

      if (this.contactForm.phone === this.profile.phone &&
          this.contactForm.email === this.profile.email) {
        this.showMessage('联系方式未发生变化', 'error');
        return;
      }

      this.contactLoading = true;
      try {
        const response = await request(`${API_BASE_URL}/api/user/update-contact`, {
          body: JSON.stringify({
            phone: this.contactForm.phone || null,
            email: this.contactForm.email || null
          })
        });

        if (response.code === '200') {
          this.showMessage('联系方式修改成功', 'success');
          this.profile = response.data;
        } else {
          this.showMessage(response.message || '修改失败', 'error');
        }
      } catch (error) {
        this.showMessage('修改失败', 'error');
      } finally {
        this.contactLoading = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    },
    generateLink() {
      if (!this.selectedArea) {
        this.showMessage('请先选择区域', 'error');
        return;
      }
      // 从配置获取基础URL，构建专属链接
      const baseUrl = config.BASE_URL || window.location.origin;
      if (this.includePersonalParams && this.profile.uuid) {
        this.generatedLink = `${baseUrl}?area=${encodeURIComponent(this.selectedArea)}&assignee=${this.profile.uuid}`;
      } else {
        this.generatedLink = `${baseUrl}?area=${encodeURIComponent(this.selectedArea)}`;
      }
      // 生成二维码（使用第三方API）
      this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(this.generatedLink)}`;
      this.showMessage('链接和二维码生成成功', 'success');
    },
    copyLink() {
      if (!this.generatedLink) return;
      navigator.clipboard.writeText(this.generatedLink).then(() => {
        this.showMessage('链接已复制到剪贴板', 'success');
      }).catch(() => {
        this.showMessage('复制失败，请手动复制', 'error');
      });
    },
    downloadQrcode() {
      if (!this.qrCodeUrl) return;
      // 创建一个临时的 a 标签来下载图片
      const link = document.createElement('a');
      link.href = this.qrCodeUrl;
      link.download = `专属链接二维码_${this.selectedArea}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.showMessage('二维码下载成功', 'success');
    },
    showMessage(msg, type) {
      this.message = msg;
      this.messageType = type;
      setTimeout(() => { this.message = ''; }, 3000);
    }
  }
};
</script>

<style scoped>
.profile-container { display: flex; flex-direction: column; gap: 24px; }
.profile-card { background-color: white; border-radius: 8px; box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1); }
.card-header { padding: 16px 24px; border-bottom: 1px solid #e5e7eb; }
.card-header h3 { margin: 0; font-size: 16px; font-weight: 600; color: #374151; }
.card-body { padding: 24px; }
.info-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 16px; }
.info-item { display: flex; flex-direction: column; gap: 4px; }
.info-item label { font-size: 14px; font-weight: 500; color: #6b7280; }
.info-item span { font-size: 14px; color: #374151; }
.role-tag { display: inline-block; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 500; width: fit-content; }
.role-admin { background-color: #fee2e2; color: #991b1b; }
.role-normal { background-color: #dbeafe; color: #1e40af; }
.status-tag { display: inline-block; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 500; width: fit-content; }
.status-normal { background-color: #d1fae5; color: #059669; }
.status-banned { background-color: #fee2e2; color: #991b1b; }
.password-form { max-width: 400px; }
.form-item { margin-bottom: 20px; }
.form-item label { display: block; margin-bottom: 8px; font-size: 14px; font-weight: 500; color: #374151; }
.form-item input { width: 100%; padding: 10px 40px 10px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 14px; }
.form-item input:focus { outline: none; border-color: #3b82f6; }
.password-input-wrapper { position: relative; }
.toggle-btn { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; padding: 4px; cursor: pointer; color: #6b7280; }
.required { color: #ef4444; }
.password-hint { font-size: 12px; color: #6b7280; margin-top: 4px; }
.hint-error { color: #ef4444; }
.contact-form { max-width: 400px; }
.input-with-hint { display: flex; flex-direction: column; gap: 4px; }
.input-hint { font-size: 12px; color: #ef4444; }
.reset-btn {
  padding: 10px 32px;
  background-color: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 12px;
}
.reset-btn:hover { background-color: #4b5563; }
.disabled-input { background-color: #f3f4f6; color: #9ca3af; cursor: not-allowed; }
.form-actions { margin-top: 24px; }
.submit-btn { padding: 10px 32px; background-color: #3b82f6; color: white; border: none; border-radius: 6px; font-size: 14px; font-weight: 500; cursor: pointer; }
.submit-btn:hover { background-color: #2563eb; }
.submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.link-form { max-width: 500px; }
.link-display { display: flex; gap: 8px; align-items: center; }
.link-display input { flex: 1; background-color: #f9fafb; }
.copy-link-btn { display: flex; align-items: center; gap: 4px; padding: 8px 16px; background-color: #10b981; color: white; border: none; border-radius: 6px; font-size: 14px; cursor: pointer; white-space: nowrap; }
.copy-link-btn:hover { background-color: #059669; }
.generate-link-btn { display: flex; align-items: center; gap: 8px; padding: 10px 32px; background-color: #8b5cf6; color: white; border: none; border-radius: 6px; font-size: 14px; font-weight: 500; cursor: pointer; }
.generate-link-btn:hover { background-color: #7c3aed; }
.generate-link-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.qrcode-container { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; }
.qrcode-image { border: 1px solid #e5e7eb; border-radius: 8px; }
.download-qrcode-btn { display: flex; align-items: center; gap: 4px; padding: 8px 16px; background-color: #3b82f6; color: white; border: none; border-radius: 6px; font-size: 14px; cursor: pointer; }
.download-qrcode-btn:hover { background-color: #2563eb; }
.form-item select { width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 14px; background-color: white; }
.form-item select:focus { outline: none; border-color: #3b82f6; }
.checkbox-label { display: flex; align-items: center; gap: 8px; cursor: pointer; font-weight: normal; }
.checkbox-label input[type="checkbox"] { width: 16px; height: 16px; cursor: pointer; }
.checkbox-label span { font-size: 14px; color: #6b7280; }
.message-toast { position: fixed; top: 20px; left: 50%; transform: translateX(-50%); padding: 12px 24px; border-radius: 6px; font-size: 14px; z-index: 2000; }
.message-toast.success { background-color: #d1fae5; color: #059669; }
.message-toast.error { background-color: #fee2e2; color: #991b1b; }
</style>
